import BigNumber from "bignumber.js";
import bn from "./bn";

export default function aprDay2apy(aprDay: BigNumber.Value) {
  const apr = bn(aprDay).toNumber()/10**18 * 365
  const secondsPerYear = 365*24*3600
  const apy = (1 + apr/secondsPerYear)**secondsPerYear - 1
  return apy
}